import { useSelector } from 'react-redux';
import { MarketCode } from '@tink/config/src/markets';
import { selectUser } from '../../core/Analytics/new-analytics';
import { useProduct } from '../../components/ApplicationProviders/ProductProvider/ProductProvider';
import { IsInTestGroupPayload, useGradualRollout } from '../../utilities/useGradualRollout';
import { PageView } from '../../models/analytics';
import { GradualReleaseLabels } from '../../utilities/useGradualRolloutTypes';
import { ProductDimensionPay } from '../../models/product';
import { ProviderEntity } from '../../models/provider';
import { applicationParameters } from '../../utilities/application-parameters';

export const useCredentialsMachineRollout = (provider?: ProviderEntity) => {
  const { market = applicationParameters.get('market') } = provider || {};
  const user = useSelector(selectUser);
  const { productDimension, productType } = useProduct();

  const { isInTestGroup: allEnabled } = useGradualRollout(
    PageView.NO_SCREEN,
    GradualReleaseLabels.XSTATE_CREDENTIALS_MACHINE
  );

  const { isInTestGroup: spainEnabled } = useGradualRollout(
    PageView.NO_SCREEN,
    GradualReleaseLabels.XSTATE_CREDENTIALS_MACHINE_FR_REDIRECT_10
  );

  const { isInTestGroup: germanyACEmbeddedEnabled } = useGradualRollout(
    PageView.NO_SCREEN,
    GradualReleaseLabels.XSTATE_CREDENTIALS_MACHINE_AC_DE_EMBEDDED_10
  );

  const testGroup: IsInTestGroupPayload = {
    userId: user?.id || '',
    market,
    productDimension,
    productType,
    provider,
  };

  /* CredentialsMachine is rolled out for the US Market in any case due to special account selector for US */
  if (market === MarketCode.US) {
    return true;
  }

  if (productDimension === ProductDimensionPay.BULK) {
    return true;
  }

  return allEnabled(testGroup) || spainEnabled(testGroup) || germanyACEmbeddedEnabled(testGroup);
};
